import React from "react";
import { Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import StaticWidgetToggle from "./StaticWidgetToggle";

const SurveyWidget = ({ disabled }) => (
  <tr data-id="survey">
    {!disabled && (
      <td className="sortable__drag-handler" />
    )}
    <td>
      <Icon icon="ios-list-outline" />
    </td>
    <td />
    <td>
      <Trans>Survey</Trans>
    </td>
    <td className="max-width-300">
      <Trans>
        This widget displays surveys available for you to take, and the results
        of surveys you have completed.
      </Trans>
    </td>
    <td className="max-width-300">
      <Trans>For You</Trans>
    </td>
    <td>
      <StaticWidgetToggle name="survey" disabled={disabled} />
    </td>
  </tr>
);

export default SurveyWidget;
